import { CatalogLayoutSubgroup } from './catalog.layout.subgroup';
import { CatalogLayoutBaseObject } from './catalog.layout.base.object';

export class CatalogLayoutMaingroup extends CatalogLayoutBaseObject {
    ID: number;
    SortOrder: number;
    Description: string;
    Subgroups: CatalogLayoutSubgroup[];
}
